import React, { useState } from "react";
import { IUserResponse, IUserDTO } from "app/api/types";

import "./styles.scss";
import EditUserForm from "app/components/EditUserForm";

interface IProps {
  user: IUserResponse;
  onDelete: (id: number) => void;
  onSubmit: (data: IUserDTO) => void;
}

const User: React.FC<IProps> = props => {
  const [isCollapsed, setCollapse] = useState(true);
  const [isDeleting, setDelete] = useState(false);

  const onDelete = () => {
    setDelete(true);
    props.user.id && props.onDelete(props.user.id);
  };

  const triggerCollapse = () => {
    setCollapse(!isCollapsed);
  };

  const styles = {
    height: !isCollapsed ? "340px" : "60px"
  };

  return (
    <div
      className={`user-container ${isDeleting ? "deleting" : ""}`}
      style={styles}
    >
      <div className="content-wrapper" onClick={triggerCollapse}>
        <div className="content-main">
          <div className="main__name">{props.user.name}</div>
          <div className="main__email">{props.user.email}</div>
        </div>

        <div className="right-block">
          {props.user.email !== "admin@admin.com" && (
            <p className="phrase-del" onClick={onDelete}>
              удалить
            </p>
          )}
        </div>
      </div>

      <EditUserForm
        user={props.user}
        onSubmit={props.onSubmit}
        isActive={!isCollapsed}
      />
    </div>
  );
};

export default User;
